export const CONSENT_STATUS = {
    ASK_ME_LATER: "ASK_ME_LATER",
    NOT_FOUND: "NOT_FOUND",
    CONSENTED: "CONSENTED",
    DECLINED: "DECLINED"
}

export const EXPERIMENT_STATUS = {
    CONTROL: "CONTROL",
    TREATMENT: "TREATMENT"
}

export const ANALYTICS_DESCRIPTION = {
    INDUCT_PROCESS_METRIC: "INDUCT_PROCESS_METRIC",
    STOW_PROCESS_METRIC: "STOW_PROCESS_METRIC",
    WIDGET_CONSENT_RESPONSE: "WIDGET_CONSENT_RESPONSE"
}